import React from 'react';
import type { Insight } from 'packages/common/types/insights';

import { InsightCard } from '../InsightCard/InsightCard';

import styles from './InsightsList.module.scss';

interface InsightsListProps {
  insights: Insight[];
  onInsightClick: (insight: Insight) => void;
}

export const InsightsList: React.FC<InsightsListProps> = ({ insights, onInsightClick }) => {
  const sortedInsights = [...insights].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());

  return (
    <>
      <h1 className={styles.pageTitle}>Latest Articles</h1>
      {sortedInsights.map((insight) => (
        <InsightCard key={insight.id} insight={insight} onClick={onInsightClick} />
      ))}
    </>
  );
};
